// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "25873" ? "vertical-insure" : chunkId) + "-" + {"25873": "5270d6da701ada8f","81505": "6a04717f9faf14a2",}[chunkId] + ".js"
}